const reducer = (state, action) => {
  switch (action.type) {
    case "SET_CLICKED_BUY_NOW": {
      return {
        ...state,
        isBuyNowClicked: action.payload,
      };
    }
    case "SET_CURRENT_USER": {
      return {
        ...state,
        user: action.payload,
      };
    }
    case "REMOVE_CURRENT_USER": {
      return {
        ...state,
        user: null,
      };
    }
    case "SET_LOADING": {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case "SET_PAYMENT_STATUS": {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case "SET_CURRENT_USER_ME": {
      return {
        ...state,
        userFullInformation: action.payload,
      };
    }
    case "REMOVE_CURRENT_USER_ME": {
      return {
        ...state,
        userFullInformation: null,
      };
    }
    case "SET_LOGIN_POP_UP": {
      return {
        ...state,
        showLogin: action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
